import { auth } from '@/utils/auth/auth'
import { publicEnv } from '@/utils/public-env'

import { ssoClient } from '@better-auth/sso/client'
import {
  adminClient,
  inferAdditionalFields,
  organizationClient
} from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  baseURL: publicEnv('NEXT_PUBLIC_AUTH_URL'),
  plugins: [
    inferAdditionalFields<typeof auth>(),
    adminClient(),
    organizationClient(),
    ssoClient()
  ]
})

export const { signIn, signOut, useSession, useActiveOrganization } = authClient
export type Session = typeof authClient.$Infer.Session
